<div style="position: fixed;top: 0px;right: 20px;z-index: 10000 ;width: 24px">
  <div class="flex-between-center w100">
    <button color="accent" (click)="closeDialog()"
      mat-mini-fab>
      <mat-icon>clear</mat-icon>
    </button>

  </div>
</div>
<mat-card style="height: 100%;overflow-y: hidden">
  <mat-card-header style="width: 100%;text-align: center;display: block;margin: 0;padding: 0">
    @if (data.title) {
      <mat-card-subtitle style="text-align: center">{{ data.title }}</mat-card-subtitle>
    }
  </mat-card-header>
  <mat-card-content style="margin: 0;padding: 0">
    <form [formGroup]="form" style="height: 100%">
      <div class="container-center w100 notShowInLandScape">
        <div class="width-dataPicker-container">
          <app-form-field-next-date formControlName="range"
            [diabledButtonWeek]="diabledButtonWeek"
            [disabledComponent]="disableButton"
            [rangeData]="true"
            [deltaDate]="deltaDate$|async"

            >
          </app-form-field-next-date>
          <!--                    <app-next-after-data (dateChange)="dateChangedTemperature($event)"-->
          <!--                                         [diabledButtonWeek]="diabledButtonWeek"-->
          <!--                                         [disabled]="disableButton"-->

          <!--                                         -->
          <!--                    >-->
        <!--                    </app-next-after-data>-->

      </div>


      <div class="width-period-container">
        <app-increment-field formControlName="periodMobileMediaMinute"
          [hintMessage]="'periodoMediaMobile'|translate"
          [min]="0"
          [max]="maxMinutePeriodDate"
          [step]="step"
          [showClearButton]="true"
          >

        </app-increment-field>


      </div>
      @if (chartTemperature != null) {
        <div class="flex-start-center ">
          <!--                            <button mat-icon-button color="primary"-->
          <!--                                    (click)="openChartFull(chartTemperature)">-->
          <!--                                <mat-icon>fullscreen</mat-icon>-->
        <!--                            </button>-->
        <button (click)="resetZoom()"
          mat-icon-button color="primary"
          [matTooltip]="'reset zoom'"
          >
          <mat-icon>center_focus_weak</mat-icon>
        </button>
        <button (click)="clickDownloadMode()" color="accent"
          [matTooltip]="'download csv'"
          mat-icon-button>
          <mat-icon>file_download</mat-icon>
        </button>
        <button (click)="downloadChartImage(chartTemperature,undefined)" color="primary"
          mat-icon-button
          [matTooltip]="'screenshot'"
          >
          <mat-icon>image</mat-icon>
        </button>
      </div>
    }
    @if (disableButton||loadDate;) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>

  <div class="visualized-in-Mobile height100vh custom-tab-group">
    <div class="containerChartMobile">

      @if (configChart$|async; as config) {
        @if (!downloadModeIsActive) {
          @if (loadChart) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
          <app-chart class="h100 w100"
            [type]="config.type"
            [data]="config.data"
            [options]="config.options"
            [plugins]="config.plugins"
            [disabledDatasetsIndex]="(hiddenLegendsIndex$|async)!"
            [activeIndex]="activeIndex"
            (chartReady)="setChart($event)"
            >
          </app-chart>

        } @else {
          <ng-container
            [ngTemplateOutlet]="DownloadCsvBox"
            >
          </ng-container>
        }
      } @else {
        <ng-container *ngTemplateOutlet="NODATA">

        </ng-container>
      }
      <mat-divider></mat-divider>

    </div>
    <mat-tab-group
      class="notShowInLandScape containerListMobile"
      headerPosition="below"
      style="position: absolute;bottom: 0;left: 0;"
      [preserveContent]="true"
      (selectedTabChange)="selecTabChange($event)">

      <mat-tab label="Legend">
        <ng-container
          [ngTemplateOutlet]="LeggendList"
          >
        </ng-container>
      </mat-tab>
      <mat-tab label="Selection">
        <mat-form-field class="w100 " style="margin-bottom: -15px">
          <mat-label>{{ 'search_generic'|translate }}</mat-label>
          <input matInput formControlName="searchName">
          <button mat-icon-button matSuffix (click)="unsetKey('searchName')">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <ng-container
          [ngTemplateOutlet]="SelectionList"
          >

        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
  <app-split-screen [breakPoint]="breakPointFilterTable" class="scrollbar-vertical visualized-in-desktop">
    <div sx class="heigth-split-screen-sx ">
      @if (typesData) {
        <div>
          <div class="flex-center-center w100">
            <div class="flex-start-center direction-button" style="max-width: 100%">
              @for (types of typesData; track types) {
                <button mat-flat-button class="wButton"
                  [color]="getColorButton(types.traduction)"
                  (click)="clickDataType(types.traduction)">
                  <div class="flex-between-center w100">
                    <div style="white-space: normal;">{{ types.traduction|sensorDataTraduction$|async }}</div>
                    @if (types.svgIcon||types.icon;) {
                      @if (types.svgIcon) {
                        <mat-icon [svgIcon]="types.svgIcon"></mat-icon>
                      } @else {
                        <mat-icon>{{ types.icon }}</mat-icon>
                      }
                    }
                  </div>
                </button>
              }
            </div>
          </div>
        </div>
      }
      @if (data.elements) {
        <mat-form-field class="w100 ">
          <mat-label>{{ 'search_generic'|translate }}</mat-label>
          <input matInput formControlName="searchName">
          <button mat-icon-button matSuffix (click)="unsetKey('searchName')">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <div style="border-right: solid 1px " class="border-color-primary ">
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node"
              #NODESCROLLABLE [id]="node.elementId"
              [ngClass]="node|transformValueByPredicateFunction:predicateFiler:(searchName$|async)">
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              <button mat-flat-button class="wButton" style="margin-right: 3px"
                [color]="getColorButtonElement(node.name,node.elementId)"
                (click)="clickDataTypeInElements(node.name,node.elementId)">
                <div class="flex-between-center w100">
                  <div style="white-space: normal;">{{ (node.name|sensorDataTraduction$)|async }}</div>
                </div>
              </button>

            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node
              *matTreeNodeDef="let node;when: hasChild"
              matTreeNodePadding="5px"
              matTreeNodeToggle
              #NODESCROLLABLE [id]="node.elementId"
              [ngClass]="node|transformValueByPredicateFunction:predicateFiler:(searchName$|async)"
              >
              <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
              {{ node.name }}
            </mat-tree-node>
          </mat-tree>
        </div>
      }
    </div>
    <div dx class="heigth-split-screen-dx">
      @if (!downloadModeIsActive) {
        <div class="title-card-container">
          @if (configChart$|async; as config) {
            @if (loadChart) {
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <app-chart class="h100 w100"
              [type]="config.type"
              [data]="config.data"
              [options]="config.options"
              [plugins]="config.plugins"
              [activeIndex]="activeIndex"
              (chartReady)="setChart($event)"
              >
            </app-chart>
          } @else {
            <ng-container *ngTemplateOutlet="NODATA">

            </ng-container>
          }
        </div>

      } @else {
        <ng-container
          [ngTemplateOutlet]="DownloadCsvBox"
          >
        </ng-container>
      }

    </div>

  </app-split-screen>

</form>
</mat-card-content>
</mat-card>
<ng-template #SelectionList>
  @if (chipsElemnts$|async; as chips) {
    <div #chipsViewport style="height: 100%; overflow-y: auto;"
      (scroll)="lastChipsScrollTop = $any($event.target).scrollTop">
      <mat-list class="max-width-list">
        @for (element of chips; track element.elementId) {
          <mat-list-item [id]="'chip-' + element.elementId" style="height: unset;">
            <div matListItemTitle style="margin-bottom: -35px;">
              <span class="text-legend">{{ element.name }}</span>
            </div>
            <div matListItemLine class="w100">
              <div style="max-width: 100%;overflow-x: scroll;padding-bottom: 7px;margin-bottom:1px">
                @for (info of element.info; track info) {
                  <mat-chip-option
                    [selected]="info.key|transformValueByPredicateFunction:getIsSelected:element.elementId:getIdDataType:(colorsDataType$|async):(dataType$|async)"
                    [color]="info.key|transformValueByPredicateFunction:getColorButtonByColors:element.elementId:getIdDataType:(colorsDataType$|async):(dataType$|async)"
                    style="margin:0 10px 0px 10px"
                    (click)="clickDataTypeInElements(info.key,element.elementId)"

                    >{{ info.key|sensorDataTraduction$|async }}
                  </mat-chip-option>
                }
              </div>
            </div>
          </mat-list-item>
        }
      </mat-list>
    </div>
  }

</ng-template>
<ng-template #LeggendList>
  @if (legendChart$|async; as legends) {
    <mat-list class="w100">
      @for (item of legends; track item) {
        <mat-list-item
          style="height: unset;min-height: 56px;" (click)="enableDisableLegend($index,item.objectId)"
          matRipple class="pointer background-color-primary-transparent-hoover">
          <div matListItemIcon
            style="width: 30px;height:10px;margin-right:10px;border-radius: 2px; border: 1px solid"
            [ngStyle]="{background:item.backgroundColor,'border-color':item.borderColor}"
            >
          </div>
          <div matListItemTitle class="flex-between-center">
            <span class="text-legend">{{ item.label }}</span>
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          </div>
        </mat-list-item>
        @if (!$last) {
          <mat-divider></mat-divider>
        }
      }
    </mat-list>

  }

</ng-template>

<ng-template #DownloadCsvBox>
  <div class="w100 h100 flex-center-center">
    <mat-card style="width: 400px;max-width: 100%">
      <mat-card-header>
        <mat-card-subtitle>
          {{ 'isPossibleSelectIndeterminate'|translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (downloadingFile.active) {
          <mat-progress-bar mode="determinate"
            [value]="downloadingFile.progress">
          </mat-progress-bar>
        }

      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="accent" (click)="clickDownloadMode()"
          style="margin-right: 10px">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-flat-button color="primary" (click)="clickDownloadChart()">
          <mat-icon>file_download</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>

<ng-template #NODATA>
  <div class="w100 h100 flex-center-center">
    <mat-card>
      <mat-card-content class="container-no-data">
        <div
          class="flex-center-center flex-direction-column heigth-content">
          <div style="flex: 3;background: lightgrey"
            class="w100 flex-center-center border">
            <mat-icon class="icon-size-large" style="color:white">insert_chart
            </mat-icon>
          </div>
          <div style="flex: 1;font-weight: bold;padding: 10px 0" class="w100 flex-center-center">
            {{ 'alert.noData'|translate }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>